import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-5" data-testid="not-found-page">
      <h1 className="font-extrabold uppercase text-4xl tracking-tight mb-4">404</h1>
      <p className="text-midnight-black/60 font-medium mb-8">This page wandered off. Let's get you back.</p>
      <Link to="/">
        <button className="bg-stranger-orange text-clean-white font-bold tracking-widest text-xs px-6 py-3 rounded-full hover:bg-orange-600 transition-colors">GO HOME</button>
      </Link>
    </div>
  );
}
